"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Actions = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Actions"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _Menu = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Menu"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var eventsUtils = _interopRequireWildcard(require("../../utils/events"));
var _ActionAssetItem = _interopRequireDefault(require("./ActionAssetItem"));
var _Download = _interopRequireDefault(require("./Download"));
var _objects = require("../../utils/objects");
var _portals = require("../../utils/portals");
var _utils = require("./utils");
var _events2 = require("./events");
var _ShareModal = _interopRequireDefault(require("./ShareModal"));
var _PublicPortalActions = _interopRequireDefault(require("./PublicPortalActions"));
var _VersionsTableActions = _interopRequireDefault(require("./VersionsTableActions"));
var _AddVersion = _interopRequireDefault(require("./AddVersion"));
var _DeleteVersionsModal = _interopRequireDefault(require("../DeleteVersionsModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DeprecateIcon = function DeprecateIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  }));
};
DeprecateIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ShareIcon = function ShareIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-4 2a4 4 0 1 1 .903 2.53l-5.967 2.755a4.017 4.017 0 0 1 0 1.43l5.967 2.754a4 4 0 1 1-.839 1.816L8.097 14.53a4 4 0 1 1 0-5.062l5.967-2.754A4.02 4.02 0 0 1 14 6zm-9 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm13 6a2 2 0 1 0-.001 4A2 2 0 0 0 18 16z"
  }));
};
ShareIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414l-1.295-1.295-.008 9.559a1 1 0 0 1-2-.002l.008-9.553-1.29 1.291a1 1 0 0 1-1.415-1.414l3-3zM4 14a1 1 0 0 1 1 1v4h14v-4a1 1 0 1 1 2 0v4c0 1.102-.898 2-2 2H5c-1.102 0-2-.898-2-2v-4a1 1 0 0 1 1-1z"
  }));
};
UploadIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 3.947C7 2.704 8.143 2 9.143 2h5.714c1 0 2.143.704 2.143 1.947V5h3a1 1 0 1 1 0 2h-.198l-.75 13.114A2 2 0 0 1 17.056 22H6.945a2 2 0 0 1-1.997-1.886L4.198 7H4a1 1 0 0 1 0-2h3V3.947zM9 5h6V4H9v1zM6.202 7l.743 13h10.11L17.8 7H6.202zM10 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1z"
  }));
};
TrashIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-8 6a8 8 0 1 1 14.32 4.906l4.387 4.387a1 1 0 0 1-1.414 1.414l-4.387-4.387A8 8 0 0 1 2 10z"
  }));
};
SearchIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.728 2.88a3.013 3.013 0 0 1 4.257 0l2.133 2.13a3.005 3.005 0 0 1 0 4.254l-2.412 2.406-9.186 9.172a1 1 0 0 1-.526.276l-4.626.849a2.005 2.005 0 0 1-2.34-2.301l.77-4.613a1 1 0 0 1 .28-.543l9.239-9.223 2.41-2.407zM18 9.55l1.704-1.701a1.005 1.005 0 0 0 0-1.424l-2.132-2.13a1.014 1.014 0 0 0-1.431 0l-1.702 1.7L18 9.55zm-4.977-2.143L4.718 15.7 4 19.995v.002h.001l.003.003h.003l4.32-.793 8.258-8.244-3.562-3.556z"
  }));
};
EditIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var MoreIcon = function MoreIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
  }));
};
MoreIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "label": "Actions__label__15Qj9",
  "popover": "Actions__popover__PUPy4",
  "more-actions": "Actions__more-actions__29ryr",
  "moreActions": "Actions__more-actions__29ryr",
  "delete-item": "Actions__delete-item__a5tmt",
  "deleteItem": "Actions__delete-item__a5tmt",
  "more-options": "Actions__more-options__2ZZJW",
  "moreOptions": "Actions__more-options__2ZZJW",
  "menu": "Actions__menu__2p9za",
  "menu-item": "Actions__menu-item__16n8N",
  "menuItem": "Actions__menu-item__16n8N",
  "popover-action": "Actions__popover-action__3AouI",
  "popoverAction": "Actions__popover-action__3AouI",
  "detail-actions": "Actions__detail-actions__1JuFL",
  "detailActions": "Actions__detail-actions__1JuFL",
  "visible": "Actions__visible__3wTwb",
  "first-action": "Actions__first-action__22GQj",
  "firstAction": "Actions__first-action__22GQj",
  "disabled": "Actions__disabled__kl_U-",
  "action": "Actions__action__183fJ",
  "detail-actions-pira": "Actions__detail-actions-pira__2_tT7",
  "detailActionsPira": "Actions__detail-actions-pira__2_tT7",
  "deprecate-icon": "Actions__deprecate-icon__1-0EU",
  "deprecateIcon": "Actions__deprecate-icon__1-0EU",
  "label-pira": "Actions__label-pira__1lsDh",
  "labelPira": "Actions__label-pira__1lsDh",
  "public-portal-actions-container": "Actions__public-portal-actions-container__33sgK",
  "publicPortalActionsContainer": "Actions__public-portal-actions-container__33sgK"
}; 
require('./Actions.css');
var buttonStyles = _Button.default.themes.DefaultTheme;
var Actions = function Actions(_ref) {
  var actions = _ref.actions,
    asset = _ref.asset,
    canEdit = _ref.canEdit,
    canAdmin = _ref.canAdmin,
    canAddVersion = _ref.canAddVersion,
    hasUnpublishedChanges = _ref.hasUnpublishedChanges,
    isDraft = _ref.isDraft,
    isEdit = _ref.isEdit,
    editURL = _ref.editURL,
    isPublishing = _ref.isPublishing,
    isMinorDeprecated = _ref.isMinorDeprecated,
    isPortalReArchitectureEnabled = _ref.isPortalReArchitectureEnabled,
    canDeleteMinor = _ref.canDeleteMinor,
    canDeprecateMinor = _ref.canDeprecateMinor,
    onPublish = _ref.onPublish,
    pagePath = _ref.pagePath,
    shareModalConfiguration = _ref.shareModalConfiguration,
    section = _ref.section,
    addRef = _ref.addRef;
  var portalConfigurationContext = _react.default.useContext(_exchangeReactHooks.AssetPortalContext);
  var _React$useState = _react.default.useState(0),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    actionsMenuKey = _React$useState2[0],
    setActionsMenuKey = _React$useState2[1];
  var modalContext = (0, _exchangeReactHooks.useModals)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var profile = (0, _exchangeReactHooks.useProfile)();
  var studioMetadata = (0, _exchangeReactHooks.useStudioMetadata)();
  var isStudio = (0, _exchangeReactHooks.useIsStudio)();
  var isPortalSearchEnabled = (0, _exchangeReactHooks.useFeatureFlag)('portal-search-enabled') && !isDraft;
  var isPublicPortal = (0, _exchangeReactHooks.useIsPublicPortal)();
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var versioningAllowance = (0, _exchangeReactHooks.useVersioningAllowance)();
  var deleteDeprecateVersionLabel = versioningAllowance === 'major' ? 'major' : 'minor';
  var isVersionsTableDisabled = (0, _exchangeReactHooks.useVersionsTableDisabled)();
  var handleSearch = _react.default.useCallback(function () {
    var event = new Event('exchange-portal-search');
    global.document.dispatchEvent(event);

    // workaround to close actions menu
    setActionsMenuKey(actionsMenuKey + 1);
  }, [actionsMenuKey]);
  var showDeleteAsset = isPortalReArchitectureEnabled && canAdmin && !isStudio && !isVersionsTableDisabled;
  var openModal = modalContext.openModal;
  var popoverContainer = _react.default.useRef(null);
  var getActionClassName = function getActionClassName(actionsToRender) {
    var className = isPortalReArchitectureEnabled ? (0, _classnames.default)(buttonStyles.button, buttonStyles.secondary, buttonStyles.md, buttonStyles.noFill, styles.action) : styles.action;
    if (actionsToRender.length === 0) {
      className = isPortalReArchitectureEnabled ? (0, _classnames.default)(buttonStyles.button, buttonStyles.primary, buttonStyles.md, styles.action, styles.firstAction) : styles.firstAction;
      return className;
    }
    if (actionsToRender.length >= 3 && !isPortalReArchitectureEnabled) {
      return (0, _classnames.default)(styles.popoverAction, styles.labelPira);
    }
    return className;
  };
  var addShareAction = function addShareAction(actionsToRender) {
    var isInShowMode = !isEdit && !isDraft;
    var isAdmin = canAdmin;
    if (!isStudio && isAdmin && isInShowMode) {
      actionsToRender.push(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: "asset-action-share"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "asset-action-share",
        "aria-describedby": "asset-action-description",
        type: "submit",
        className: getActionClassName(actionsToRender),
        onClick: function onClick() {
          return openModal(_ShareModal.default, {
            asset: asset,
            visibility: portalConfigurationContext.visibility,
            customCallouts: shareModalConfiguration
          });
        }
      }, !isPortalReArchitectureEnabled ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "s",
        isDecorative: true
      }, /*#__PURE__*/_react.default.createElement(ShareIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, styles.label, !isPortalReArchitectureEnabled))
      }, "Share")), /*#__PURE__*/_react.default.createElement("span", {
        id: "asset-action-description",
        className: "visually-hidden"
      }, "Opens share asset modal")));
    }
    return actionsToRender;
  };
  var addDownloadAction = function addDownloadAction(actionsToRender) {
    var isInShowMode = !isEdit && !isDraft;
    var _getTypeFiles = (0, _portals.getTypeFiles)(portalConfigurationContext === null || portalConfigurationContext === void 0 ? void 0 : portalConfigurationContext.files, asset, studioMetadata, 'private-portal-actions', config),
      files = _getTypeFiles.files;
    var hasFiles = files.length > 0;
    if (isInShowMode && hasFiles) {
      actionsToRender.push(/*#__PURE__*/_react.default.createElement(_Download.default, {
        key: "asset-action-download",
        asset: asset,
        canEdit: canEdit,
        onDownload: function onDownload(file) {
          (0, _utils.trackDownloadForMarketo)({
            asset: asset,
            profile: profile,
            isStudio: isStudio,
            studioMetadata: studioMetadata
          });
          trackEvent(_events2.EVENT_TYPES.ASSET_DOWNLOADED, (0, _utils.assetDownloadProperties)({
            asset: asset,
            file: file,
            isInstall: isStudio
          }));
        }
      }));
    }
    return actionsToRender;
  };
  var addEditAction = function addEditAction(actionsToRender) {
    if (!isStudio && !isEdit && canEdit) {
      actionsToRender.push(/*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        "data-test-id": "asset-action-edit",
        key: "asset-action-edit",
        className: actionsToRender.length >= 3 ? styles.popoverAction : styles.action,
        to: editURL
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "s",
        isDecorative: true
      }, /*#__PURE__*/_react.default.createElement(EditIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.label
      }, "Edit")));
    }
    return actionsToRender;
  };
  var addPublishAction = function addPublishAction(actionsToRender) {
    var type = asset.type,
      groupId = asset.groupId,
      assetId = asset.assetId,
      version = asset.version,
      versionGroup = asset.versionGroup,
      minorVersion = asset.minorVersion;
    var isInShowDraftMode = !isEdit && isDraft;
    if (canEdit && !isStudio && isInShowDraftMode && hasUnpublishedChanges) {
      actionsToRender.push(/*#__PURE__*/_react.default.createElement("form", {
        "data-test-id": "asset-publish-form",
        key: "asset-publish-form",
        action: "/".concat(groupId, "/").concat(assetId, "/").concat(version, "?_method=PATCH"),
        method: "POST",
        onSubmit: function onSubmit(event) {
          return event.preventDefault();
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "asset-action-publish",
        className: "".concat(isPublishing ? "".concat(styles.disabled, " ") : '').concat(actionsToRender.length >= 3 ? styles.popoverAction : styles.action),
        type: "button",
        onClick: function onClick() {
          return onPublish({
            type: type,
            groupId: groupId,
            assetId: assetId,
            version: version,
            minorVersion: minorVersion,
            versionGroup: versionGroup,
            isEditMode: false,
            pagePath: pagePath || config.defaultPageName
          });
        }
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "s"
      }, /*#__PURE__*/_react.default.createElement(UploadIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.label
      }, isPublishing ? 'Publishing ...' : 'Publish'))));
    }
    return actionsToRender;
  };
  var addDeprecateAction = function addDeprecateAction(actionsToRender) {
    var isInShowMode = !isEdit && !isDraft;
    var isAdmin = canAdmin;
    var DeprecateAssetModal = portalConfigurationContext.components.DeprecateAssetModal;
    if (isAdmin && !isStudio && isInShowMode && canDeprecateMinor && !isMinorDeprecated && !isPortalReArchitectureEnabled) {
      actionsToRender.push({
        testId: 'deprecate-asset-action',
        key: 'deprecate-asset-action',
        className: getActionClassName(actionsToRender),
        icon: /*#__PURE__*/_react.default.createElement(DeprecateIcon, null),
        iconClassName: styles.deprecateIcon,
        description: 'Opens deprecate modal',
        label: "Deprecate ".concat(deleteDeprecateVersionLabel),
        onClick: function onClick() {
          return openModal(DeprecateAssetModal, {
            asset: asset,
            isMinorDeprecation: false
          });
        }
      });
    }
    return actionsToRender;
  };
  var addRevertDeprecateAction = function addRevertDeprecateAction(actionsToRender) {
    var isInShowMode = !isEdit && !isDraft;
    var RevertDeprecateAssetModal = portalConfigurationContext.components.RevertDeprecateAssetModal;
    if (canAdmin && !isStudio && isInShowMode && canDeprecateMinor && isMinorDeprecated && !isPortalReArchitectureEnabled) {
      actionsToRender.push({
        testId: 'revert-deprecation-action',
        key: 'revert-deprecation-action',
        className: getActionClassName(actionsToRender),
        icon: /*#__PURE__*/_react.default.createElement(WarningIcon, null),
        description: 'Opens revert asset deprecation modal',
        label: 'Revert deprecation',
        onClick: function onClick() {
          return openModal(RevertDeprecateAssetModal, {
            asset: asset,
            isMinorDeprecation: false
          });
        }
      });
    }
    return actionsToRender;
  };
  var addDeleteAction = function addDeleteAction(actionsToRender) {
    var isInShowMode = !isEdit && !isDraft;
    var isAdmin = canAdmin;
    var DeleteAssetModal = portalConfigurationContext.components.DeleteAssetModal;
    if (isAdmin && isInShowMode && !isStudio && canDeleteMinor) {
      actionsToRender.push({
        testId: 'delete-asset-action',
        key: 'delete-asset-action',
        className: getActionClassName(actionsToRender),
        icon: /*#__PURE__*/_react.default.createElement(TrashIcon, null),
        label: "Delete ".concat(deleteDeprecateVersionLabel),
        description: 'Opens delete modal',
        onClick: function onClick() {
          return openModal(DeleteAssetModal, {
            asset: asset
          });
        }
      });
    }
    return actionsToRender;
  };
  var addAdditionalActions = function addAdditionalActions(actionsToRender) {
    actions({
      isStudio: isStudio,
      isEdit: isEdit,
      isDraft: isDraft,
      section: 'private-portal-actions'
    }).forEach(function (action) {
      var label = action.label,
        description = action.description,
        actionId = action.id,
        icon = action.icon,
        href = action.href,
        _onClick = action.onClick,
        tooltip = action.tooltip;
      var key = "asset-action-".concat(actionId);
      actionsToRender.push({
        testId: key,
        key: key,
        description: description,
        className: getActionClassName(actionsToRender),
        icon: icon,
        label: label,
        href: href,
        tooltip: tooltip,
        onClick: function onClick() {
          (0, _events2.trackGenericActionEvent)({
            asset: asset,
            actionId: actionId,
            section: 'private-portal-actions',
            trackEvent: trackEvent
          });
          _onClick === null || _onClick === void 0 || _onClick();
        }
      });
    });
    return actionsToRender;
  };
  var actionsToRender = [];
  if (section === 'public-portal-actions' || isPublicPortal) {
    return /*#__PURE__*/_react.default.createElement(_PublicPortalActions.default, {
      asset: asset,
      isEdit: isEdit,
      isDraft: isDraft,
      isStudio: isStudio,
      actions: actions
    });
  }
  if (section === 'versions-table') {
    return /*#__PURE__*/_react.default.createElement(_VersionsTableActions.default, {
      asset: asset,
      isEdit: isEdit,
      isDraft: isDraft,
      isStudio: isStudio,
      actions: actions,
      addRef: addRef
    });
  }
  addShareAction(actionsToRender);
  addDownloadAction(actionsToRender);
  if (!isPortalReArchitectureEnabled) {
    addEditAction(actionsToRender);
    addPublishAction(actionsToRender);
  }
  addAdditionalActions(actionsToRender);
  addDeprecateAction(actionsToRender);
  addRevertDeprecateAction(actionsToRender);
  addDeleteAction(actionsToRender);
  actionsToRender = actionsToRender.filter(function (action) {
    return action;
  });
  var additionalActions = !isPortalReArchitectureEnabled ? actionsToRender.splice(3) : [];
  var additionalActionsMenu = additionalActions.map(function (additionalAction, index) {
    var actionProps = /*#__PURE__*/_react.default.isValidElement(additionalAction) ? additionalAction.props : additionalAction;
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      className: styles.menuItem
      /* eslint-disable-next-line react/no-array-index-key */,
      key: "asset-action-item-".concat(index),
      testId: "asset-action-item-".concat(index),
      onClick: actionProps.onClick ? actionProps.onClick : function () {},
      href: actionProps.href,
      target: actionProps.href ? '_blank' : undefined,
      onKeyDown: !actionProps.href ? eventsUtils.onEnterKey(actionProps.onClick) : undefined
    }, /*#__PURE__*/_react.default.isValidElement(additionalAction) ? additionalAction : /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, (0, _extends2.default)({}, (0, _objects.omit)(actionProps, 'href', 'onClick'), {
      showIcon: false
    })));
  });
  if (actionsToRender.length === 0 && !isPortalReArchitectureEnabled) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("section", {
    id: "asset-actions",
    className: isPortalReArchitectureEnabled ? styles.detailActionsPira : styles.detailActions,
    "data-test-id": "asset-actions",
    "aria-label": "Asset actions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.visible,
    "data-test-id": "asset-actions-visible"
  }, actionsToRender.map(function (action) {
    return /*#__PURE__*/_react.default.isValidElement(action) ? action : /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, (0, _extends2.default)({}, action, {
      showIcon: false
    }));
  })), canAddVersion ? /*#__PURE__*/_react.default.createElement(_AddVersion.default, {
    asset: asset
  }) : null, isPortalReArchitectureEnabled ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.moreOptions
  }, /*#__PURE__*/_react.default.createElement(_Actions.default, {
    offset: [-8, 15],
    key: actionsMenuKey
  }, isPortalSearchEnabled ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    className: styles.menuItem,
    testId: "search-action",
    onKeyDown: eventsUtils.onEnterKey(handleSearch)
  }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
    onClick: handleSearch,
    className: styles.popoverAction,
    icon: /*#__PURE__*/_react.default.createElement(SearchIcon, null),
    showIcon: false,
    label: "Search for content",
    testId: "search-content-action-item",
    description: "Search for content"
  })) : null, showDeleteAsset ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    className: styles.menuItem,
    testId: "delete-version-action",
    onKeyDown: eventsUtils.onEnterKey(function () {
      return openModal(_DeleteVersionsModal.default, {
        asset: asset
      });
    })
  }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
    onClick: function onClick() {
      return openModal(_DeleteVersionsModal.default, {
        asset: asset
      });
    },
    className: (0, _classnames.default)(styles.popoverAction, styles.deleteItem),
    icon: /*#__PURE__*/_react.default.createElement(TrashIcon, null),
    showIcon: false,
    label: "Delete versions",
    testId: "delete-version-action-item",
    description: "Opens delete version modal"
  })) : null)) : null, additionalActions.length !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.popover,
    ref: popoverContainer
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.current;
    },
    testId: "asset-action-options",
    offset: isPortalReArchitectureEnabled ? [-15, 20] : [0, 0],
    anchorPosition: "br",
    popupPosition: "tr",
    triggerOn: ['click'],
    content: /*#__PURE__*/_react.default.createElement(_Menu.default, {
      className: styles.menu
    }, additionalActionsMenu)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.moreActions,
    "aria-label": "Show more asset actions",
    size: "s"
  }, /*#__PURE__*/_react.default.createElement(MoreIcon, null)))) : null);
};
Actions.defaultProps = {
  canDeleteMinor: false,
  canDeprecateMinor: false,
  actions: function actions() {
    return [];
  },
  openModal: function openModal() {}
};
var _default = exports.default = Actions;
//# sourceMappingURL=Actions.js.map